// Animations

$j(function() {
	var isReduced = window.matchMedia('(prefers-reduced-motion: reduce)') === true || window.matchMedia('(prefers-reduced-motion: reduce)').matches === true;

	if (!isReduced) {
		lax.init();

		// Scroll parallax animations.

		lax.addDriver('scrollY', function() {
			return window.scrollY;
		});

		lax.addElements('.parallax-y-1', {
			scrollY: {
				translateY: [
					['elInY', 'elOutY'],
					{
						992: [0, -40],
						1280: [0, -80]
					},
					{
						inertia: .05
					}
				]
			}
		});

		lax.addElements('.parallax-y-2', {
			scrollY: {
				translateY: [
					['elInY', 'elOutY'],
					{
						992: [0, -60],
						1280: [0, -120]
					},
					{
						inertia: .05
					}
				]
			}
		});

		lax.addElements('.parallax-y-3', {
			scrollY: {
				translateY: [
					['elInY', 'elOutY'],
					{
						992: [0, -80],
						1280: [0, -160]
					},
					{
						inertia: .05
					}
				]
			}
		});

		// Count Numbers Up.

		$j('.number-animation').waypoint(function(direction) {
			var element = this.element,
				numbers = $j(element).find('.number-value').not('.finished-counting');

			if (direction === 'down') {
				$j(element).addClass('number-animation--in-view');

				numbers.delay(1000).countTo({
					speed: 700,
					refreshInterval: 2,
					formatter: function(value, options) {
						var newValue = value.toFixed(options.decimals);
						newValue = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
						return newValue;
					},
					onComplete: function() {
						this.addClass('finished-counting');
					}
				});
			}
		}, {
			offset: '100%'
		});
	}
});
